import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorTextComponent } from './error-text.component';

@NgModule({
  declarations: [ErrorTextComponent],
  imports: [CommonModule],
  exports: [ErrorTextComponent],
})
export class ErrorTextModule {}
